import { Component } from '@angular/core';
import { BrochureService } from 'app/services/brochure.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent {

  constructor(private brochure: BrochureService) {}

  get brochureHome(): string {
    return this.brochure.home;
  }
}
